import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

type Props = {
  isPending?: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export const DividendUpdateConfirmModal: FC<Props> = ({ isPending, onClose, onSuccess }) => (
  <div className="m-2 flex w-full min-w-[300px] flex-col gap-8 rounded bg-white p-4 xlg:w-[453px]">
    <div className="flex flex-col gap-4">
      <span className="text-xl font-[550] text-gray-700">
        <AppFormattedMessage id="UPDATE_DIVIDEND_PAYOUT_TITLE" />
      </span>
      <span className="text-xs font-[450] text-gray-500">
        <AppFormattedMessage id="UPDATE_DIVIDEND_PAYOUT_DESCRIPTION" />
      </span>
    </div>
    <div className="flex h-11 justify-end gap-4">
      <Button
        className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
        onClick={onClose}
        styleType="NONE"
      >
        <AppFormattedMessage id="NO" />
      </Button>
      <Button
        className="h-full w-fit px-6 py-[10px] text-sm font-[550] text-white"
        isLoading={isPending}
        onClick={onSuccess}
      >
        <AppFormattedMessage id="YES_UPDATE" />
      </Button>
    </div>
  </div>
);
